import { createPopper } from "@popperjs/core";

/**
 * This module adds code to abstract popup functionality. We're currently
 * using popper: https://popper.js.org/
 *
 * As popup functionality becomes more complex, this module should be extended
 * to support the new features without exposing the details of the popup
 * library we're using.
 */

// https://popper.js.org/docs/v2/constructors/#options
const defaultOpts = {
    placement: "bottom",
    modifiers: [
        {
            name: "preventOverflow",
            options: { padding: 24 }
        },
        {
            name: "offset",
            options: { offset: [0, 8] },
        },
    ] // https://popper.js.org/docs/v2/modifiers/
};

export function createPopup(toggle, el, opts) {
    const popperOptions = Object.assign({}, defaultOpts, opts);
    return createPopper(toggle, el, popperOptions);
}
